import styled from 'styled-components';

export const Container = styled.div`
    background-color: #f7f7f7;
    z-index: 1;
    position: relative;
    overflow: visible;
`;

type WrapperProps = { $gridHeight: number };

export const Wrapper = styled.div.attrs<WrapperProps>(({ $gridHeight }) => ({
    style: { paddingBottom: `${$gridHeight}%` },
}))<WrapperProps>`
    width: 100%;
    position: relative;
    overflow: visible;
`;
